import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { useState, useCallback } from 'react'
import { RootState } from '@/store/store'
import { selectAgentConversationFormIncludeUnpublishedCases } from '@/agent-v2/chat-form/store/selectors'
import { researchFiltersActions } from '../store/slice'
import { selectSelectedStateNames, selectHasRelatedFederalContent } from '../store/selectors'

/**
 * Custom hook to manage state selection (multi-select, max 2)
 *
 * Handles:
 * - Selected states (array)
 * - Warning banner
 * - State toggle
 */
export function useStateSelection(conversationId: string) {
  const dispatch = useAppDispatch()
  const [showWarningBanner, setShowWarningBanner] = useState(false)

  const selectedStates = useAppSelector((state: RootState) => selectSelectedStateNames(state, { conversationId }))

  const includeRelatedFederalContent = useAppSelector((state: RootState) => selectHasRelatedFederalContent(state, { conversationId }))

  const includeUnpublishedCases = useAppSelector((state: RootState) => selectAgentConversationFormIncludeUnpublishedCases(state, { conversationId }))

  const handleStateToggle = useCallback(
    (stateName: string) => {
      dispatch(researchFiltersActions.toggleStateSelected({ conversationId, stateName }))
      setShowWarningBanner(false)
    },
    [conversationId, dispatch, setShowWarningBanner]
  )

  return {
    selectedStates,
    showWarningBanner,
    includeRelatedFederalContent,
    handleStateToggle,
    setShowWarningBanner,
    includeUnpublishedCases,
  }
}
